import React from 'react';
import '../Scene.css';

function Smoke2 () {
  return (
    <div id="smoke-2">
      <span className="s0"></span>
      <span className="s1"></span>
      <span className="s2"></span>
      <span className="s3"></span>
      <span className="s4"></span>
      <span className="s5"></span>
      <span className="s6"></span>
      <span className="s7"></span>
      <span className="s8"></span>
      <span className="s9"></span>
    </div>
  );
}

export default Smoke2;